import { render, staticRenderFns } from "./SurveyTextarea.vue?vue&type=template&id=77436112&"
import script from "./SurveyTextarea.vue?vue&type=script&lang=js&"
export * from "./SurveyTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports